import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import { ErrorSummary } from '@digdir/designsystemet-react';

import { ErrorGroupWrapper } from '../formErrors/styledComponents';
import { useOppvarmingFormContext } from '../../utils';
import { ErrorLinkItem } from '../formErrors/errorLinkItem';

export const VarmepumpeErrorSummary = () => {
  const { formState } = useOppvarmingFormContext();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.varmepumpe' });

  const errors = formState.errors.varmepumpe?.value;

  if (!errors) {
    return null;
  }
  // Radiator and gulvvarme selection is validated as a group and has common validation and error message.
  // We only display radiator error message.
  const fordelingssystemSelectionError = errors?.vannbarenVarme?.radiator?.selected;

  return (
    <Fragment>
      <ErrorGroupWrapper>
        <ErrorSummary.Heading>{t('label')}</ErrorSummary.Heading>
        <ErrorSummary.List>
          <ErrorLinkItem error={errors?.varmekilde} />
          <ErrorLinkItem error={errors?.vannbarenVarme?.varmesentral?.installasjonsAr} />
          <ErrorLinkItem error={errors?.vannbarenVarme?.varmesentral?.vetInstallasjonsAr} />
          <ErrorLinkItem error={errors?.vannbarenVarme?.varmesentral?.varmesentralType} />
          <ErrorLinkItem error={errors?.vannbarenVarme?.varmesentral?.installertIOppvarmetRom} />
          <ErrorLinkItem error={errors?.varmefordeling} />
          <ErrorLinkItem error={errors?.punktoppvarming?.installasjonsAr} />
          <ErrorLinkItem error={errors?.punktoppvarming?.vetInstallasjonsAr} />
          <ErrorLinkItem error={errors?.punktoppvarming?.serviceGjennomfortSiste2Ar} />
          <ErrorLinkItem error={errors?.vannbarenVarme?.installasjonsAr} />
          <ErrorLinkItem error={errors?.vannbarenVarme?.vetInstallasjonsAr} />
          <ErrorLinkItem error={errors?.vannbarenVarme?.serviceGjennomfortSiste2Ar} />
          <ErrorLinkItem error={errors?.vannbarenVarme?.bruk?.romoppvarming} />
          <ErrorLinkItem error={fordelingssystemSelectionError} />
          <ErrorLinkItem error={errors?.vannbarenVarme?.radiator?.value?.termostatstyring} />
          <ErrorLinkItem error={errors?.vannbarenVarme?.gulvvarme?.value?.termostatstyring} />
        </ErrorSummary.List>
      </ErrorGroupWrapper>
    </Fragment>
  );
};
